import { __assign, __extends } from "tslib";
/**
 * Created by Ewa.Podrazka on 2017-04-27.
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import BSSPackageValidation from '@main/externals/bss-package-validation/js/bss-package-validation.js';
import BSSTableComponent from '../../bss-table-component/js/bss-table-component.js';
import template from '../template/popup.hbs';
import templateExample from '../template/popup-example.hbs';
import sendEmailTemplate from '../template/popup-send-email.hbs';
import popupTextTemplate from '../template/popup-text.hbs';
import representativeExampleTemplate from '../template/popup-representative-example.hbs';
import monthlyRatesTemplate from '../template/popup-monthly-rates.hbs';
import filterTemplate from '../template/popup-filter.hbs';
import BSSMultivalueManagerComponent from '../../bss-multivalue-manager-component/js/bss-multivalue-manager-component';
import _ from 'lodash';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSPopupComponent class
 */
var templateObject = {
    defaultTemplate: template,
    exampleTemplate: templateExample,
    sendEmailTemplate: sendEmailTemplate,
    popupTextTemplate: popupTextTemplate,
    representativeExampleTemplate: representativeExampleTemplate,
    monthlyRatesTemplate: monthlyRatesTemplate,
    filterTemplate: filterTemplate,
};
var BSSPopupComponent = /** @class */ (function (_super) {
    __extends(BSSPopupComponent, _super);
    /**
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     * @listens {bss-popup-showOnEvent-$COMPONENT-ID}
     * @listens {bss-popup-recalculateOnEvent-$COMPONENT-ID}
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     */
    function BSSPopupComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        logger.info('PopupComponent: => constructor : componentId: ' +
            _this._config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, logger, toolbox);
        /**
         * @desc stores component name and version @@name and @@version is replaced in build task with data from package.json
         * @type {String}
         * @private
         */
        _this._componentVersion = '@@name ver. @@version';
        /**
         * @desc document
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$document = _this._toolbox.$(document);
        /**
         * @desc popup open button element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$openBtn = _this._toolbox.$(_this._config.openButton);
        /**
         * @desc popup close button element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$closeBtnExternal = _this._toolbox.$(_this._config.closeButton);
        /**
         * @desc popup element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$popup = null;
        /**
         * @desc parent popup element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$parentPopup = null;
        /**
         * @desc cover content overlay
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$cover = _this._entityTemplate.find('.bss-popup_overlay');
        /**
         * @desc close button element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$closeBtn = null;
        /**
         * @desc indicates whether form validation is needed
         * @type {Boolean}
         * @private
         */
        _this._validationSettings = _this._config.validationSettings;
        /**
         * @desc name of tag event on open popup
         * @type {string}
         * @private
         */
        _this._tagOpenEventName = _this._config.tagOpenEventName
            ? _this._config.tagOpenEventName
            : null;
        /**
         * @desc name of tag event on close popup
         * @type {string}
         * @private
         */
        _this._tagCloseEventName = _this._config.tagCloseEventName
            ? _this._config.tagCloseEventName
            : null;
        /**
         * @type {boolean}
         * @private
         * @desc describe that simulator is in popup
         */
        _this._isInPopup = _this._entityTemplate.attr('is-popup')
            ? JSON.parse(_this._entityTemplate.attr('is-popup'))
            : typeof _this._config.isInPopup === 'undefined'
                ? false
                : _this._config.isInPopup;
        /**
         * @desc this flag prevent position calculation -> in _generatePopupPosition
         * @type {boolean}
         */
        _this._isGeneratePopupPositionOff = _this._config.generatePopupPositionOff
            ? _this._config.generatePopupPositionOff
            : false;
        _this._isRelativePositionPopup = _this._config.relativePositionPopup
            ? _this._config.relativePositionPopup
            : false;
        _this._fixedOuterEl = _this._toolbox.$(_this._config.fixedOuterElementSelector);
        _this._isDynamicText = _this._config.dynamicText
            ? _this._config.dynamicText
            : false;
        /**
         * @desc selector name - popup opens relative to this selector name
         * @type {String}
         * @private
         */
        _this._relativeToElement = _this._config.relativeToElement || null;
        _this._tableComponent = null;
        _this._initial_slider_data = null;
        if (_this._fixedOuterEl.length) {
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc external fixed element
             */
            _this._fixedOuterEl = _this._toolbox.$(_this._config.fixedOuterElementSelector);
            /**
             * @type {Number}
             * @private
             * @desc outer container position
             */
            _this._fixedOuterElPosition = _this._fixedOuterEl.position().top;
        }
        else {
            _this._fixedOuterEl = null;
        }
        _this._isInModalPopup = null;
        var classNameBodyContainer = _this._entityTemplate.attr('data-name-body');
        if (classNameBodyContainer) {
            _this._isInModalPopup = _this._componentScope
                .closest(_this._toolbox.$(classNameBodyContainer))
                .has('#' + _this._componentScope.attr('id')).length;
        }
        else {
            _this._isInModalPopup = _this._toolbox
                .$('.modal-body')
                .has('#' + _this._componentScope.attr('id')).length;
        }
        _this._initializeCover();
        _this._$openBtn.on('click.' + _this._config.componentId, _this.loadPopup.bind(_this));
        _this._isResizeEventOff = true;
        _this._bindResize();
        _this._eventManager.subscribe('bss-start-resize-for-' + _this._config.entityInstanceId, _this._bindResize.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._eventManager.subscribe('bss-stop-resize-for-' + _this._config.entityInstanceId, _this._unbindResize.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._$contentSlides = _this._entityTemplate
            .find('#' + _this._config.componentId + ' .bss-popup--filter-content')
            .find('.bss-popup--filter-slider');
        if (_this._validationSettings) {
            _this._validation = new BSSPackageValidation(_this._validationSettings, toolbox, eventManager);
            _this._eventManager.subscribe('bss-entity-created-' + _this._config.entityInstanceId, _this._initializeValidationCustomMethods.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        }
        if (_this._config.showOnStart) {
            _this.loadPopup();
        }
        if (_this._config.sliderData) {
            _this._createSliderDescription();
            _this._injectSlider();
        }
        _this.addEventListeners();
        return _this;
    }
    BSSPopupComponent.prototype._injectSlider = function () {
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _injectSliders | Params: ');
        this._filterSliders = [];
        var _self = this;
        this._initial_slider_data = _.cloneDeep(_self._sliderComponentsDescription);
        this._$contentSlides.each(function () {
            _self._filterSliders[0] = new BSSMultivalueManagerComponent(_self._entityTemplate, _self._toolbox.$(this), _self._sliderComponentsDescription, _self._eventManager, _self._formatter, _self._resolution, _self._toolbox);
        });
    };
    /**
     * @desc method for create ui-description of each slider
     * @private
     */
    BSSPopupComponent.prototype._createSliderDescription = function () {
        logger.info('BSSFilterComponent: ' +
            this._config.componentId +
            ' => function : _createSliderDescription | ');
        this._sliderComponentsDescription = this._config.sliderData;
        this._sliderComponentsDescription.texts = this._config.texts;
        this._sliderComponentsDescription.resultData = this._config.resultData;
        this._sliderComponentsDescription.title = this._config.filterTitle;
        this._sliderComponentsDescription.minTitle = this._config.minTitle;
        this._sliderComponentsDescription.maxTitle = this._config.maxTitle;
        this._sliderComponentsDescription.between =
            this._config.texts.general.between_label;
        this._sliderComponentsDescription.entityInstanceId =
            this._config.entityInstanceId;
        this._sliderComponentsDescription.isInPopup = true;
        if (this._config.buttonFilterText) {
            this._sliderComponentsDescription.buttonText =
                this._config.texts.general[this._config.buttonFilterText];
        }
        else {
            this._sliderComponentsDescription.buttonText = this._entityTemplate
                .find(this._toolbox.$("#".concat(this._config.sliderData.buttonToUpdate)))
                .text();
        }
    };
    /**
     * Add component event listeners
     * @public
     */
    BSSPopupComponent.prototype.addEventListeners = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : addEventListeners');
        if (this._config.showOnEvent) {
            this._eventManager.subscribe('bss-popup-showOnEvent-' + this._config.componentId, this.loadPopup.bind(this), this.subscriberPrefix + this._config.componentId);
        }
        // Close popup on update of any simulator component's data
        if (this._config.closeOnDataChange) {
            this._eventManager.subscribe("bss-data-changed-".concat(this._config.entityInstanceId), this.hidePopup.bind(this), this.subscriberPrefix + this._config.componentId);
        }
        if (this._config.recalculateOnEvent) {
            this._eventManager.subscribe('bss-popup-recalculateOnEvent-' + this._config.componentId, this._generatePopupPosition.bind(this), this.subscriberPrefix + this._config.componentId);
            // used when another component wants to recalculate a popup component, like on BC filters popups
            this._eventManager.subscribe('bss-popup-recalculateOnEvent', this._generatePopupPosition.bind(this), this.subscriberPrefix + this._config.componentId);
        }
        this._eventManager.subscribe('bss-progress-bar-end-' + this._config.entityInstanceId, this.loadPopup.bind(this), this.subscriberPrefix + this._config.componentId);
        if (this._relativeToElement) {
            this._window.on('resize.' + this._config.componentId, this._toolbox._.throttle(this._setRelativePopupPositioningInResolution.bind(this), 200));
            this._window.on('scroll.' + this._config.componentId, this._toolbox._.throttle(this.hidePopup.bind(this), 200));
        }
    };
    /**
     * @desc initialize validation custom method.
     * @private
     */
    BSSPopupComponent.prototype._initializeValidationCustomMethods = function () {
        this._validation.loadCustomMethods();
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSPopupComponent.prototype._bindResize = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._window.on('resize.' + this._config.componentId, this._resizeFix.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc component update
     * @override
     */
    BSSPopupComponent.prototype.update = function (publisherName, data) {
        logger.info('BSSListBoxComponent:: ' +
            this._config.componentId +
            ' => function : _update' +
            ' | Params: ', publisherName, data);
        _super.prototype.update.call(this, publisherName, data);
        this._setBCButtonCarsNumber();
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSPopupComponent.prototype._unbindResize = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc base initialize cover method
     * @private
     */
    BSSPopupComponent.prototype._initializeCover = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _initializeCover');
        if (!this._$cover.length) {
            this._entityTemplate.append('<div class="bss-popup_overlay">&nbsp;</div>');
            this._$cover = this._entityTemplate.find('.bss-popup_overlay');
        }
    };
    /**
     * @desc base load popup method
     * @public
     */
    BSSPopupComponent.prototype.loadPopup = function (name, data) {
        if (name === void 0) { name = null; }
        if (data === void 0) { data = null; }
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : loadPopup | Params: ', name, data);
        this._$popup = this._componentScope;
        this._$popupContent = this._$popup.find('.bss-popup_content');
        if (this._config.parentPopup) {
            this._$parentPopup = this._$popup.parents(this._config.parentPopup);
        }
        if (this._isDynamicText && !this._config.description && data) {
            var textContainer = this._$popupContent.find('.bss-popup_text-row .bss-popup_text');
            var tableContent = this._$popupContent.find('.bss-popup_table_row');
            tableContent.removeAttr('style');
            textContainer.html(data.disclaimer);
            if (data.calculations && data.calculations.length) {
                var tableConfig = {};
                tableConfig.containerId = this._config.componentId + '_table';
                tableConfig.componentId =
                    this._config.componentId + '_calculationDetailsTable';
                tableConfig.componentType = 'TableComponent';
                tableConfig.componentTemplate = 'twoColumnsTableTemplate';
                tableConfig.level = parseInt(this._config.level) + 1;
                tableConfig.order = 0;
                tableConfig.productId = this._config.productId;
                tableConfig.data = data.calculations;
                tableConfig.remoteUpdate = false;
                tableConfig.testId = "".concat(this._config.testId, "_popup-table");
                this._tableComponent = new BSSTableComponent(this._entityTemplate, '#' + tableConfig.containerId, tableConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
            }
            else {
                if (tableContent) {
                    tableContent.css('display', 'none');
                }
            }
        }
        //set buttonCarsNumber only for BC
        this._setBCButtonCarsNumber();
        this._showPopup();
        this._bindCloseEvents();
    };
    /**
     * @desc set number of cars depending on the view on which popup is located
     * (models view or variants view)
     * this method applies only to BC
     */
    BSSPopupComponent.prototype._setBCButtonCarsNumber = function () {
        logger.info('PopupComponent: ' +
            this._config.componentId +
            ' => function :  _setBCButtonCarsNumber');
        var resultData = this._config.resultData[this._config.productId[0]];
        var showCarsButton = this._componentTemplate.find('#filterResult')[0];
        if ((resultData === null || resultData === void 0 ? void 0 : resultData.modelsList) && showCarsButton) {
            showCarsButton.textContent = resultData.showModelsButtonText;
        }
        else if ((resultData === null || resultData === void 0 ? void 0 : resultData.variantsList) && showCarsButton) {
            showCarsButton.textContent = resultData.showVariantsButtonText;
        }
    };
    /**
     * @desc set relative popup positioning in relation to a resolution = on mobile center popup,
     * on desktop - do calculations and stick popup to a relative element
     * @private
     */
    BSSPopupComponent.prototype._setRelativePopupPositioningInResolution = function () {
        logger.info('PopupComponent: ' +
            this._config.componentId +
            ' => function :  _setRelativePopupPositioningInResolution');
        var res = this._resolution.getCurrent();
        if (res === 'xs') {
            // for mobile resolution remove no-transform class, remove inline top & left style
            this._$componentEl.removeClass('bss-popup_no-transform');
            this._$componentEl.css({ top: '', left: '' });
        }
        else {
            // for desktop resolution do calculations = position popup relative to a ui-desc element
            this._calculateRelativePopupPositioning();
        }
    };
    /**
     * @desc adjust popup positioning in relation to a relative element set in ui-desc
     * @private
     */
    BSSPopupComponent.prototype._calculateRelativePopupPositioning = function () {
        var _a, _b;
        logger.info('PopupComponent: ' +
            this._config.componentId +
            ' => function :  _calculateRelativePopupPositioning');
        var $relativeToElement = this._entityTemplate.find(this._relativeToElement);
        // if only one relative element found
        if ($relativeToElement.length === 1) {
            this._$componentEl.removeClass('bss-popup_no-transform');
            this._$componentEl.css({ top: '', left: '' });
            var popupTop = null;
            var popupLeft = null;
            var popupBottom = null;
            var relativeToElementRectCalc = ((_a = $relativeToElement[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || null;
            var relativeToElementTop = (relativeToElementRectCalc === null || relativeToElementRectCalc === void 0 ? void 0 : relativeToElementRectCalc.top) || null;
            var relativeToElementLeft = (relativeToElementRectCalc === null || relativeToElementRectCalc === void 0 ? void 0 : relativeToElementRectCalc.left) || null;
            var relativeToElementMarginTop = parseInt($relativeToElement.css('marginTop'), 10);
            var relativeToElementMarginLeft = parseInt($relativeToElement.css('marginLeft'), 10);
            var relativeToElementHeight = $relativeToElement.outerHeight();
            var windowHeight = this._window.outerHeight();
            var $entityPopup = this._getEntityPopupContainer();
            if (this._isInPopup && ($entityPopup === null || $entityPopup === void 0 ? void 0 : $entityPopup.length)) {
                // if BC in popup
                var entityPopupRectCalc = ((_b = $entityPopup[0]) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) || null;
                var entityPopupTop = (entityPopupRectCalc === null || entityPopupRectCalc === void 0 ? void 0 : entityPopupRectCalc.top) || null;
                var entityPopupLeft = (entityPopupRectCalc === null || entityPopupRectCalc === void 0 ? void 0 : entityPopupRectCalc.left) || null;
                var entityPopupBottom = windowHeight - entityPopupTop - $entityPopup.outerHeight();
                popupTop =
                    relativeToElementTop - entityPopupTop + relativeToElementMarginTop;
                popupLeft =
                    relativeToElementLeft - entityPopupLeft + relativeToElementMarginLeft;
                popupBottom =
                    windowHeight -
                        entityPopupTop -
                        entityPopupBottom -
                        popupTop -
                        relativeToElementHeight;
            }
            else {
                // if BC in body
                popupTop = relativeToElementTop + relativeToElementMarginTop;
                popupLeft = relativeToElementLeft + relativeToElementMarginLeft;
                popupBottom = windowHeight - popupTop - relativeToElementHeight;
            }
            if (popupTop !== null && popupLeft !== null) {
                var top_1;
                if (popupTop < popupBottom) {
                    // align popup top line with relative element top line
                    top_1 = popupTop;
                }
                else {
                    // align popup bottom line with relative element bottom line
                    top_1 =
                        popupTop -
                            this._$componentEl.outerHeight() +
                            relativeToElementHeight;
                }
                this._$componentEl.css({
                    top: top_1,
                    left: popupLeft,
                });
                this._$componentEl.addClass('bss-popup_no-transform');
            }
        }
    };
    /**
     * @desc returns entity popup selector
     */
    BSSPopupComponent.prototype._getEntityPopupContainer = function () {
        logger.info("PopupComponent: ".concat(this._config.componentId, " => function : _getEntityPopupContainer"));
        var popupContainer = null;
        var classNameContentContainer = this._entityTemplate.attr('data-name-content');
        if (classNameContentContainer) {
            popupContainer = this._componentScope.closest(this._toolbox.$(classNameContentContainer));
        }
        return popupContainer;
    };
    /**
     * @desc base show popup method
     * @emits {bss-popup-start-$COMPONENT-ID}
     * @private
     */
    BSSPopupComponent.prototype._showPopup = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _showPopup');
        if (this._tagOpenEventName) {
            this._publishTaggingEvents(this._tagOpenEventName);
        }
        this._disableScrollbar();
        this._loadingImg();
        this._showCover();
        this._renderPopup();
        this._eventManager.publish('bss-popup-start-' + this._config.componentId, 'bss-popup-component');
    };
    /**
     * @desc base generate popup position method
     * @private
     */
    BSSPopupComponent.prototype._generatePopupPosition = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _generatePopupPosition');
        var res = this._resolution.getCurrent();
        if (this._$popup && !this._isGeneratePopupPositionOff) {
            this._$popup.removeAttr('style');
            this._$popupContent.removeAttr('style');
            var parentHeight = void 0;
            var paddingBottom = parseInt(this._$popup.css('padding-bottom'));
            var paddingTop = parseInt(this._$popup.css('padding-top'));
            var activePopupHeaderHeight = this._$popup.find('.bss-popup_header').outerHeight(true) || 0;
            var activePopupFooterHeight = this._$popup.find('.bss-popup_footer').children().outerHeight(true) ||
                0;
            var activePopupContent = this._$popupContent.outerHeight(true);
            var newContentHeight = void 0;
            var popupMaxH = void 0;
            if (this._$parentPopup) {
                parentHeight = this._$parentPopup.height();
            }
            else {
                parentHeight = window.innerHeight || this._window.height();
            }
            // max-width and max-height is a string with value in percentage, eg. '60%'
            popupMaxH = this._$popup.css('max-height');
            if (this._tableComponent && res && res === 'xs') {
                this._$popup.css('height', '100%');
                this._$popup.css('width', '100%');
            }
            else if (this._tableComponent) {
                this._$popup.css('height', '80%');
                this._$popup.css('width', '80%');
            }
            if (popupMaxH.split('')[popupMaxH.length - 1] === '%') {
                popupMaxH =
                    (parseFloat(this._$popup.css('max-height')) / 100.0) * parentHeight;
            }
            else {
                popupMaxH = parseFloat(this._$popup.css('max-height'));
            }
            newContentHeight = parseInt(popupMaxH -
                activePopupHeaderHeight -
                activePopupFooterHeight -
                paddingBottom -
                paddingTop);
            if (activePopupContent > newContentHeight) {
                this._$popupContent.css('height', newContentHeight);
            }
            else {
                this._$popupContent.css('height', 'auto');
            }
        }
        // if popup should open relative to some element
        if (this._relativeToElement) {
            this._setRelativePopupPositioningInResolution();
        }
    };
    /**
     * @desc base render popup method
     * @private
     */
    BSSPopupComponent.prototype._renderPopup = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _renderPopup');
        var showClass = this._config.showClass;
        if (showClass && typeof showClass === 'string') {
            var self_1 = this;
            this._$popup
                .addClass(showClass)
                .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                self_1._$popup.removeClass(showClass);
            });
        }
        this._$popup.addClass('is-active');
        if (this._$parentPopup && this._isRelativePositionPopup) {
            this._$parentPopup.addClass('bss-hidden-element-without-popup');
            this._scrollTop();
        }
        this._generatePopupPosition();
        // iphone/ipad safari-browser fix for car details popup in modal
        if (this._config.componentTemplate === 'popupTextTemplate' &&
            this._isInModalPopup &&
            this._entityTemplate.hasClass('browser-safari') &&
            this._entityTemplate.is('.iPhone, .iPad') &&
            this._componentScope.closest('.modal.fade.in').length) {
            this._closestModalWebkitOverflowScrolling = !this
                ._closestModalWebkitOverflowScrolling
                ? getComputedStyle(this._componentScope.closest('.modal.fade.in')[0])
                    .webkitOverflowScrolling
                : this._closestModalWebkitOverflowScrolling;
            this._componentScope.closest('.modal.fade.in')[0].style.webkitOverflowScrolling = 'auto';
        }
    };
    /**
     * @desc base scroll top method
     * @private
     */
    BSSPopupComponent.prototype._scrollTop = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _scrollTop');
        var top = this._$parentPopup.offset().top;
        if (this._fixedOuterEl && this._fixedOuterEl.is(':visible')) {
            top -= this._fixedOuterEl.outerHeight() + this._fixedOuterElPosition;
        }
        this._htmlBody.animate({ scrollTop: top }, 1000);
    };
    /**
     * @desc base loading img method
     * @private
     */
    BSSPopupComponent.prototype._loadingImg = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _loadingImg');
        var images = this._$popup.find('img.' + this._config.imgWaitForLoadingClass);
        if (images.length) {
            var self_2 = this;
            this._toolbox._.forEach(images, function (image) {
                var img = new Image();
                img.onload = function () {
                    self_2._toolbox.$(image).addClass('img-loaded');
                    if (self_2._config.recalculatePopupPosition) {
                        self_2._generatePopupPosition();
                    }
                };
                img.onerror = function () {
                    self_2._toolbox.$(image).addClass('img-error');
                };
                img.src = image.src;
            });
        }
    };
    /**
     * @desc base show cover method
     * @private
     */
    BSSPopupComponent.prototype._showCover = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _showCover');
        if (this._config.showCover) {
            this._entityTemplate.addClass('bss-popup-is-active');
            this._$cover.addClass('is-active');
            if (this._config.onCoverClickExit) {
                this._$cover.on('click.' + this._config.componentId, this.hidePopup.bind(this));
            }
        }
    };
    /**
     * @desc base hide popup method
     * @public
     */
    BSSPopupComponent.prototype.hidePopup = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : hidePopup');
        if (this._$popup) {
            var hideClass = this._config.hideClass;
            if (hideClass && typeof hideClass === 'string') {
                var self_3 = this;
                this._$popup
                    .addClass(hideClass)
                    .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                    self_3._removePopup();
                });
            }
            else {
                this._removePopup();
            }
            this._eventManager.publish('bss-popup-hide-' + this._config.componentId, 'bss-popup-component');
            if (this._tagCloseEventName) {
                this._publishTaggingEvents(this._tagCloseEventName);
            }
            // iphone/ipad safari-browser fix for car details popup in modal
            if (this._config.componentTemplate === 'popupTextTemplate' &&
                this._isInModalPopup &&
                this._entityTemplate.hasClass('browser-safari') &&
                this._entityTemplate.is('.iPhone, .iPad') &&
                this._closestModalWebkitOverflowScrolling &&
                this._componentScope.closest('.modal.fade.in').length) {
                this._componentScope.closest('.modal.fade.in')[0].style.webkitOverflowScrolling =
                    this._closestModalWebkitOverflowScrolling;
            }
        }
    };
    /**
     * Publish tagging events.
     * @param {string} tagEventName
     * @private
     */
    BSSPopupComponent.prototype._publishTaggingEvents = function (tagEventName) {
        logger.info('PopupComponent: ' +
            this._config.componentId +
            ' => function :  _publishTaggingEvents | Params: ', tagEventName);
        this._publishDxpTaggingEvents(tagEventName);
    };
    /**
     * Publish DXP tagging events.
     * @param tagEventName
     * @private
     */
    BSSPopupComponent.prototype._publishDxpTaggingEvents = function (tagEventName) {
        var _a, _b;
        (_b = (_a = this._toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[this._toolbox.currentEntity.entityId]) === null || _b === void 0 ? void 0 : _b.publish(tagEventName, __assign(__assign({}, this._config.resultData[this._config.productId[0]]), { triggerName: 'bss-button' }), this._config.taggingTriggerName || '');
    };
    /**
     * @desc base remove popup method
     * @private
     */
    BSSPopupComponent.prototype._removePopup = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _removePopup');
        if (this._$popup) {
            this._$popup.removeClass('is-active');
            this._$popup.removeClass(this._config.hideClass);
            if (this._config.componentTemplate === 'popupTextTemplate' &&
                this._config.watcher) {
                this._$popup.addClass('bss-watcher-hide');
            }
        }
        this._$popup = null;
        this._entityTemplate.removeClass('bss-popup-is-active');
        if (this._$parentPopup && this._isRelativePositionPopup) {
            this._$parentPopup.removeClass('bss-hidden-element-without-popup');
        }
        this._removeCover();
        this._enableScrollbar();
        this._unbindCloseEvents();
        if (this._tableComponent) {
            this._tableComponent.destroy();
        }
    };
    /**
     * @desc base remove cover method
     * @private
     */
    BSSPopupComponent.prototype._removeCover = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _removeCover');
        if (this._$cover) {
            this._$cover.removeClass('is-active');
        }
    };
    /**
     * @desc disable scrollbar method
     * @private
     */
    BSSPopupComponent.prototype._disableScrollbar = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _disableScrollbar');
        if (this._config.bodyNoScrollbar) {
            this.bodyScrollTop = this._$document.scrollTop();
            this._bodyStyle = this._htmlBody.attr('style');
            this._htmlBody.css({
                top: -this.bodyScrollTop + 'px',
                position: 'fixed',
                'overflow-y': 'hidden',
                width: '100%',
            });
        }
    };
    /**
     * @desc enable scrollbar method
     * @private
     */
    BSSPopupComponent.prototype._enableScrollbar = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _enableScrollbar');
        if (this._config.bodyNoScrollbar) {
            this._htmlBody.attr('style', this._bodyStyle);
            this._htmlBody.css('top', -this.bodyScrollTop + 'px');
            this._htmlBody.animate({ scrollTop: this.bodyScrollTop }, 0);
        }
    };
    /**
     * @desc resize fix method
     * @private
     */
    BSSPopupComponent.prototype._resizeFix = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _resizeFix');
        if (this._$popup && this._$popup.css('display') !== 'none') {
            this._generatePopupPosition();
        }
    };
    /**
     * @desc bind close event method which close popup on ESC press or click on button
     * @listens {bss-popup-close-events-$COMPONENT-ID}
     * @private
     */
    BSSPopupComponent.prototype._bindCloseEvents = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _bindCloseEvents');
        this._$closeBtn = this._$popup.find('.bss-popup_close-btn');
        this._$closeBtn
            .off('click.' + this._config.componentId)
            .on('click.' + this._config.componentId, this.hidePopup.bind(this));
        this._$closeBtnExternal
            .off('click.' + this._config.componentId)
            .on('click.' + this._config.componentId, this.hidePopup.bind(this));
        if (this._config.closeOnEvent) {
            this._eventManager.subscribe('bss-popup-close-events-' + this._config.componentId, this.hidePopup.bind(this), this.subscriberPrefix + this._config.componentId);
        }
        this._$document.on('keydown.' + this._config.componentId, this._bindEscPress.bind(this));
    };
    /**
     * @desc unbind close event method
     * @private
     */
    BSSPopupComponent.prototype._unbindCloseEvents = function () {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _unbindCloseEvents');
        if (this._config.closeOnEvent) {
            this._eventManager.unsubscribe('bss-popup-close-events-' + this._config.componentId, this.hidePopup.bind(this), this.subscriberPrefix + this._config.componentId);
        }
    };
    /**
     * @desc bind esc press method
     * @param {Event} e
     * @private
     */
    BSSPopupComponent.prototype._bindEscPress = function (e) {
        logger.info('PopupComponent ' +
            this._config.componentId +
            ' => function : _bindEscPress' +
            ' | Params: ', e);
        if (e.keyCode === 27) {
            this.hidePopup();
        }
    };
    /**
     * @desc destroys and call super method
     * @public
     * @override
     */
    BSSPopupComponent.prototype.destroy = function () {
        logger.info('PopupComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        _super.prototype.destroy.call(this);
    };
    return BSSPopupComponent;
}(BSSAbstractComponent));
export default BSSPopupComponent;
